import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import CrudMain from "../../../components/crud/CrudMain";
import FormikForm from "../../../components/crud/FormikForm";
import { Field } from "formik";
import TextInput from "../../../components/form-fields/TextInput";
import * as yup from "yup";
import { Nav, Tab, Button } from "react-bootstrap";
import FileUpload from "../../../components/fields/FileUpload";
import EmailInput from "../../../components/form-fields/EmailInput";
import Select from "../../../components/form-fields/Select";
import TextArea from "../../../components/form-fields/TextArea";
import Checkbox from "../../../components/form-fields/Checkbox";
import LastStatus from "../demand-update/partial-views/LastStatus";
import Documents from "../demand-update/partial-views/Documents";
import TimesSpent from "../demand-update/partial-views/TimesSpent";
import DocumentHistory from "../demand-update/partial-views/DocumentHistory";
import CurrencyInput from "../../../components/form-fields/CurrencyInput";
import ReactDatePicker from "../../../components/form-fields/ReactDatePicker";
import { useTranslation } from "react-i18next"; /* Added Line */
import { DEMAND_TYPES, MASRAF_TAB_CASES, CASE_TYPES1, CASE_TYPES2, DEMAND_TYPE_CASES_1, DEMAND_TYPE_CASES_2 } from "../../../shared/enums";
import MultiSelect from "../../../components/form-fields/MultiSelect";
import { formatCurrencyWithDouble } from "../../../utils";
import moment from "moment";
import request from "../../../services/request";
import { ThemeContext } from '../../../../context/ThemeContext';
import Expenses from "../demand-update/partial-views/Expenses";

DocumentUpdate.propTypes = {};

function DocumentUpdate(props) {
  const [configData, setConfigData] = useState(null);
  const [initialValues, setInitialValues] = useState({});
  const [disableButtons, setDisableButtons] = useState(false);
  const [t, i18n] = useTranslation(); /* Added Line */
  const [bedel, setBedel] = useState();
  const { isDisAvukat, IsMasrafCheck, userObj } = useContext(ThemeContext);
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [companies, setCompanies] = useState([]);
  const [combineCompanies, setCombineCompanies] = useState([]);
  const [isGucuTextboxVisibility, setIsGucuTextboxVisibility] = useState(false);
  const [disableIsGucu, setDisableIsGucu] = useState(false);
  const [ilgiliSirketAreaVisibility, setIlgiliSirketAreaVisibility] = useState(false);
  const [ilgiliSirketTextboxVisibility, setIlgiliSirketTextboxVisibility] = useState(false);
  const [slctdDavaTuru, setSlctdDavaTuru] = useState(-1);
  const [davaTuru2Options, setDavaTuru2Options] = useState([]);
  const [sorumluEpostaTextboxVisibility, setSorumluEpostaTextboxVisibility] = useState(false);
  const [sorumluAdiTextboxVisibility, setSorumluAdiTextboxVisibility] = useState(false);

  const validationSchema = yup.object({});

  const davaTuru2Types = [
    CASE_TYPES1.ARABULUCULUK_SURECLERI,
    CASE_TYPES1.VERGI_DAVALARI,
    CASE_TYPES1.IS_DAVALARI,
    CASE_TYPES1.YENI_SAVCILIK_SIKAYETI_YAPILMASI,
    CASE_TYPES1.ALEYHE_SAVCILIK_SIKAYETININ_TAKIBI
  ];

  var tarafText = "";

  useEffect(() => {
    getCompanies();
    getCombinedCompanies();
    checkIsGucu();
    checkIlgiliSirket();
  }, [props.showModal]);

  const checkIsGucu = () => {
    if (props.selectedRow?.isGucuBirimId === 132) {
      setIsGucuTextboxVisibility(true);
    } else {
      setIsGucuTextboxVisibility(false);
    }
  };

  const checkIlgiliSirket = () => {
    props.selectedRow?.ilgiliSirket ? setIlgiliSirketAreaVisibility(true) : setIlgiliSirketAreaVisibility(false)
    props.selectedRow?.ilgiliSirketText ? setIlgiliSirketTextboxVisibility(true) : setIlgiliSirketTextboxVisibility(false)
  };

  const onIsGucuBirimChange = (id) => {
    if(id === 132) {
      setIsGucuTextboxVisibility(true);
    } else {
      setIsGucuTextboxVisibility(false);
    }
  };

  const arrangeBeforePersist = (values) => {
    let payload = {
      talepDto: {
        id: values.id,
        davali: values.davali,
        sorumluAdi: values.sorumluAdi,
        sorumluEposta: values.sorumluEposta,
        sorumluTel: values.sorumluTel,
        dosyaTuruId: values.dosyaTuruId,
        dosyaTuruList: values.dosyaTuruList?.map(s => { return { "dosyaTurId": s } }),
        konu: values.konu,
        aciklama: values.aciklama,
        isGucuBirimId: values.isGucuBirimId,
        isGucuBirimIdDiger: values.isGucuBirimIdDiger,
        durumId: values.durumId,
        fileIds: values.fileIds ? values.fileIds.map((f) => f.id) : [],
        taraf1: values.taraf1,
        davaTuru: values.davaTuru,
        sirketId: values.sirketId,
        basvurulanSirket: values.basvurulanSirket,
        yonlendiriciYorum: values.yonlendiriciYorum,
        avukatYorumu: values.avukatYorumu,
        avukatId: values.avukatId,
        yorumlar: values.yorumlar,
        ihtarEden: values.ihtarEden,
        bedel:
          values.bedel &&
          parseFloat(values.bedel.toString().replaceAll(",", "")),
        szlThmBedelTuru: values.szlThmBedelTuru,
        paraBirimi: values.paraBirimi,
        dil: values.dil,
        vekilSirket: values.vekilSirket,
        davaTarihi: values.davaTarihi || null,
        daireNo: values.daireNo,
        icraNo: values.icraNo,
        mudahil: values.mudahil,
        dosyaDurumId: values.dosyaDurumId || null,
        dosyaDurum: values.dosyaDurum,
        talepTur: values.talepTur,
        gorevlendirilmisDisAvukatlar: (Array.isArray(values.gorevlendirilmisDisAvukatlar) ? values.gorevlendirilmisDisAvukatlar?.map(s => { return { "userId": s } }) : [{ "userId": values.gorevlendirilmisDisAvukatlar }]),
        talepBilgideTutList: values.bilgideTutulanlar.map((bt) => {
          return {
            talepId: props.selectedRow.id,
            userId: bt,
          };
        }),
        davaliCompanyList: values.davaliCompanyList?.map(s => { return { "companyId": s } }),
        tarafCompanyList: values.tarafCompanyList?.map(s => { return { "companyId": s } }),
        onemli: values.updateOnemli,
        ilgiliSirketId: values.ilgiliSirketId,
        ilgiliSirketText: values.ilgiliSirketText,
        ikinciDavaTuru: values.ikinciDavaTuru,
        ilkDavaTuru: values.ilkDavaTuru
      },
      dosyaDto: {
        id: values.dosyaId,
        baslangicTarihi: values.baslangicTarihi || null,
        bitisTarihi: values.bitisTarihi || null,

        sicilKaydiValue: values.sicilKaydiValue,
        sirkularValue: values.sirkularValue,
        cezaValue: values.cezaValue,
        dosyaTuru: values.dosyaTuruId,
      },
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    /* setDisableButtons(!data.departmanYoneticisiMi); */
    if (props.selectedRow?.disableButton) {
      setDisableButtons(true);
    }
    let adaptedData = {
      id: data.id,
      talepEdenSirket: data.company.name,
      sirketId: data.sirketId,
      taraf1: data.taraf1,
      sorumluAdi: data.sorumluAdi,
      sorumluEposta: data.sorumluEposta,
      sorumluTel: data.sorumluTel,
      dosyaTuruId: data?.dosyaTur?.id,
      dosyaTuruList: data.dosyaTuruList?.map((c) => c.dosyaTurId),
      konu: data.konu,
      aciklama: data.aciklama,
      isGucuBirimId: data.isGucuBirimId,
      isGucuBirimIdDiger: data.isGucuBirimIdDiger,
      yonlendiriciYorum: data.yonlendiriciYorum,
      avukatYorumu: data.avukatYorumu,
      avukatId: data.avukatId,
      yorumlar: data.yorumlar,
      fileIds: data.fileIds,
      GHIBYetkilisiGorebilir: data.GHIBYetkilisiGorebilir,
      dil: data.dil,
      ihtarEden: data.ihtarEden,
      dosyaId: data.dosya && data.dosya.id,
      dosyaNo: data.dosya && data.dosya.dosyaNo,
      sicilKaydiValue:
        data.dosya &&
          data.dosya.dosyaAttribute &&
          data.dosya.dosyaAttribute.length > 0 &&
          data.dosya.dosyaAttribute.find((da) => da.attributeId == 1).value ==
          "false"
          ? false
          : true,
      sirkularValue:
        data.dosya &&
          data.dosya.dosyaAttribute &&
          data.dosya.dosyaAttribute.length > 0 &&
          data.dosya.dosyaAttribute.find((da) => da.attributeId == 2).value ==
          "false"
          ? false
          : true,
      cezaValue:
        data.dosya &&
          data.dosya.dosyaAttribute &&
          data.dosya.dosyaAttribute.length > 0 &&
          data.dosya.dosyaAttribute.find((da) => da.attributeId == 3).value ==
          "false"
          ? false
          : true,
      baslangicTarihi:
        data.dosya &&
        data.dosya.baslangicTarihi &&
        new Date(data.dosya.baslangicTarihi),
      bitisTarihi:
        data.dosya &&
        data.dosya.bitisTarihi &&
        new Date(data.dosya.bitisTarihi),
      dosyaDurumId: data.dosyaDurumId,
      dosyaDurum: data.dosyaDurum,
      talepTur: data.talepTur,
      bedel: data.bedel && formatCurrencyWithDouble(data.bedel),
      szlThmBedelTuru: data.szlThmBedelTuru,
      paraBirimi: data.paraBirimi,
      vekilSirket: data.vekilSirket,
      davaTarihi: data.davaTarihi && new Date(data.davaTarihi),
      bilgideTutulanlar: data.talepBilgideTutList?.map((bt) => bt.userId),
      cdate: data.cdate && new Date(data.cdate),

      davali: data.davali,
      daireNo: data.daireNo,
      icraNo: data.icraNo,
      basvurulanSirket: data.basvurulanSirket,
      redNedeni: data.redNedeni,
      redEdenUserId: data.redEdenUserFullName,
      redTarihi: data.redTarihi && new Date(data.redTarihi),

      mudahil: data.mudahil,
      davaTuru: data.davaTuru,
      gorevlendirilmisDisAvukatlar: (Array.isArray(data.gorevlendirilmisDisAvukatlar) ? data.gorevlendirilmisDisAvukatlar?.map((c) => c.userId) : data.gorevlendirilmisDisAvukatlar),
      gorevlendirilenDisAvukat: data.gorevlendirilenDisAvukatFullName,
      davaliCompanyList: data.davaliCompanyList?.map((c) => c.companyId),
      tarafCompanyList: data.tarafCompanyList?.map((c) => c.companyId),
      onemli: data.updateOnemli,
      ilgiliSirketId: data.ilgiliSirketId,
      ilgiliSirketText: data.ilgiliSirketText,
      ikinciDavaTuru: data.ikinciDavaTuru,
      ilkDavaTuru: data.ilkDavaTuru      
    };

    setInitialValues(adaptedData);
    
    setSlctdDavaTuru(data.ilkDavaTuru);

    if (configData?.tumKullanicilar.filter(a => a.label == adaptedData.sorumluAdi).length == 0) {
      setSorumluAdiTextboxVisibility(true);
    }
    if (configData?.tumKullanicilar.filter(a => a.otherValue == adaptedData.sorumluEposta).length == 0) {
      setSorumluEpostaTextboxVisibility(true);
    }
  };

  const typeCheck = (type, filterValues = []) => {
    let index = filterValues.findIndex((fv) => fv == type);

    if (index != -1) {
      return true;
    }

    return false;
  };

  const onBedelChanged = (val) => {
    props.selectedRow.szlThmBedelTuru = val;
    setBedel(val);
  };

  const getCompanies = () => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          /* companyGroupIds: companyGroupIds, */
          /* yurtici: (_homeCompany && _abroadCompany) || (!_homeCompany && !_abroadCompany) ? null : _homeCompany, */
          talepTurId: props.selectedRow?.talepTur.id
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCompanies(response.body.tableData);
      }
    });
  };

  const getCombinedCompanies = () => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          /* companyGroupIds: companyGroupIds, */
          /* yurtici: (_homeCompany && _abroadCompany) || (!_homeCompany && !_abroadCompany) ? null : _homeCompany, */
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCombineCompanies(response.body.tableData);
      }
    });
  };

  const getDavaTuru1Options = () => {

    let data = configData?.ilkDavaTurleri || (() => {
      return Object.keys(CASE_TYPES2).map((i) => {
        return { label: i, value: CASE_TYPES2[i] };
      });
    })();

    if (!(props.selectedRow && props.selectedRow.talepTur.id)) {
      return [];
    }
    const types = DEMAND_TYPE_CASES_1[props.selectedRow.talepTur.id] || [];
    return data.filter(a => types.indexOf(a.value) > -1);
  }
  
  const getDavaTuru2 = () => {
    let data = configData?.ikinciDavaTurleri || (() => {
      return Object.keys(CASE_TYPES2).map((i) => {
        return { label: i, value: CASE_TYPES2[i] };
      });
    })();

    const types = DEMAND_TYPE_CASES_2[slctdDavaTuru] || [];
    return data.filter(a => types.indexOf(a.value) > -1);
  };

  if (props.selectedRow) {
    switch (props.selectedRow.talepTur.id) {
      case DEMAND_TYPES.VEKALETNAME:
        tarafText = "demandCreate.vekil";
        break;
      case DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI:
        tarafText = "demandCreate.vekil";
        break;
      case DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI:
        tarafText = "demandCreate.vekil";
        break;
      case DEMAND_TYPES.SOZLESME:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.GH_IS_HUKUKU:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.TIO_SOZLESME:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.ORTAKLIKJV_KURULUSU:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.HACIZ_IHBARNAMELERI:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.PLADIS_HACIZ:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI:
        tarafText = "demandList.karsiTaraf";
        break;
      case DEMAND_TYPES.IHTARNAME_HAZIRLANMASI:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.TIO_MUTALAA:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.FMH_IHTARNAME_HAZIRLANMASI:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.TIO_IHTARNAME:
        tarafText = "demandCreate.ihtarEdilen";
        break;
      case DEMAND_TYPES.SAVCILIK:
        tarafText = "demandCreate.musteki";
        break;
      case DEMAND_TYPES.PLADIS_SAVCILIK:
        tarafText = "demandCreate.musteki";
        break;
      case DEMAND_TYPES.TIO_SAVCILIK:
        tarafText = "demandCreate.musteki";
        break;
      case DEMAND_TYPES.DAVA_ICRA_HUKUKU_RAPOR:
        tarafText = "demandCreate.ilgiliSirket";
        break;
      case DEMAND_TYPES.MP_RAPORLAMALAR:
        tarafText = "demandCreate.ilgiliSirket";
        break;
      case DEMAND_TYPES.PLADIS_RAPORLAMALAR:
        tarafText = "demandCreate.ilgiliSirket";
        break;
      case DEMAND_TYPES.TIO_RAPORLAMALAR:
        tarafText = "demandCreate.ilgiliSirket";
        break;
      case DEMAND_TYPES.FMH_RAPORLAMALAR:
        tarafText = "demandCreate.ilgiliSirket";
        break;
      case DEMAND_TYPES.RESMI_KURUM_TALEP:
        tarafText = "demandCreate.resmiDaire";
        break;
      case DEMAND_TYPES.ICRA_TAKIBI:
        tarafText = "demandCreate.alacakli";
        break;
      case DEMAND_TYPES.PLADIS_ICRA:
        tarafText = "demandCreate.alacakli";
        break;
      case DEMAND_TYPES.TIO_ICRA_TAKIBI:
        tarafText = "demandCreate.alacakli";
        break;

      default:
        tarafText = "demandCreate.davaci";
        break;
    }
  }

  return (
    <div className="row">
      <div className="col-xl-12 col-xxl-12">
        <CrudMain
          showModal={props.showModal}
          setShowModal={props.setShowModal}
          setInitialValues={setInitialValues}
          hideNewAddButton
          title={props.title}
          size={"lg"}
        >
          <Tab.Container defaultActiveKey={"bilgiler"}>
            <Nav as="ul" className="nav-tabs">
              <Nav.Item as="li" key={1}>
                <Nav.Link eventKey={"bilgiler"}>{t("tabs.bilgiler")}</Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" key={2}>
                <Nav.Link eventKey={"sondurum"}>{t("tabs.sonDurum")}</Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" key={3}>
                <Nav.Link eventKey={"dokumanlar"}>
                  {t("tabs.dokumanlar")}
                </Nav.Link>
              </Nav.Item>
              {!isDisAvukat && (
                <>
                  <Nav.Item as="li" key={4}>
                    <Nav.Link eventKey={"harcanansureler"}>
                      {t("tabs.harcananSureler")}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li" key={5}>
                    <Nav.Link eventKey={"dosyagecmisi"}>
                      {t("tabs.talepAkisi")}
                    </Nav.Link>
                  </Nav.Item>
                </>
              )}
              { props.selectedRow && IsMasrafCheck && (typeCheck(props.selectedRow.talepTur.id, MASRAF_TAB_CASES )) && (
                <Nav.Item as="li" key={6}>
                  <Nav.Link eventKey={"masraflar"}>
                    {t("tabs.masraflar")}
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
            <Tab.Content className="pt-4">
              <Tab.Pane eventKey={"bilgiler"} key={1}>
                <FormikForm
                  keyField={"bilgilerForm"}
                  isUpdating={props.isUpdating}
                  entityId={
                    props.selectedRow &&
                    (props.selectedRow.talep
                      ? props.selectedRow.talep.id
                      : props.selectedRow.id)
                  }
                  entityFetchId="id"
                  endPointUrl={props.endpoint}
                  configParameterName="talepTurId"
                  configParameterValue={
                    props.selectedRow &&
                    (props.selectedRow.talep
                      ? props.selectedRow.talep.talepTur.id
                      : props.selectedRow.talepTur.id)
                  }
                  configReqType={"POST"}
                  fetchPointUrl="dosya/find"
                  editPointUrl={props.endpoint}
                  configPointUrl="dosya/config"
                  arrangeBeforePersist={arrangeBeforePersist}
                  adaptDataForUpdate={adaptDataForUpdate}
                  setConfigData={(data) => {
                    setConfigData(data);
                  }}
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  closeModal={() => {
                    props.setShowModal(false);
                    setSorumluAdiTextboxVisibility(false);
                    setSorumluEpostaTextboxVisibility(false);
                  }}
                  refreshList={() => props.setRefreshList(!props.refreshList)}
                  okButtonText={props.okButtonText}
                  disableButtons={disableButtons}
                  endPointUrl3={props.endPointUrl3}
                  thirdSubmitButttonText={props.thirdSubmitButttonText}
                  disAvukatArsiv="dosya/guncelle"
                >
                  {!isDisAvukat && <Field
                    name="id"
                    label={t("documentUpdate.islemNo")}
                    colNumber="6"
                    component={TextInput}
                    readOnly
                  />}
                  {!isDisAvukat && <Field
                    name="talepEdenSirket"
                    label={t("demandUpdate.talepEdenSirket")}
                    colNumber="6"
                    component={TextInput}
                    readOnly
                  />}
                  {!isDisAvukat && <Field
                    name="dosyaNo"
                    label={t("documentUpdate.dosyaNo")}
                    colNumber="6"
                    component={TextInput}
                    readOnly
                  />}
                  {!isDisAvukat && <Field
                    name="cdate"
                    label={t("demandUpdate.talepTarihi")}
                    colNumber="6"
                    component={ReactDatePicker}
                    readOnly
                  />}
                  { ilgiliSirketAreaVisibility &&
                    <div className="form-group col-md-6">
                      <Field
                        name="ilgiliSirketId"
                        label={t("demandCreate.ilgiliSirket")}
                        colNumber="-6"
                        buttonLabel = {
                          <>
                            <Button
                              className="btn-xs ml-3 px-2 py-1 rounded-circle"
                              variant="primary"
                              onClick={() => setIlgiliSirketTextboxVisibility(!ilgiliSirketTextboxVisibility)}
                            >
                                <i className={ "fa fa-" + (ilgiliSirketTextboxVisibility ? "minus" : "plus") }/>
                            </Button>
                          </>
                        }
                        component={Select}
                        options={companies.map(item => { return { value: item.id, label: item.name } })}
                        required            
                      />
                      { ilgiliSirketTextboxVisibility &&
                        <Field
                          name="ilgiliSirketText"
                          label={t("demandCreate.other")}
                          colNumber="-6 hide-label"
                          component={TextInput}
                        />
                      }
                    </div>
                  }
                  {!isDisAvukat && <Field
                    name="fileIds"
                    label={t("documentUpdate.dosya")}
                    colNumber="12"
                    component={FileUpload}
                  />}
                  {!isDisAvukat && 
                  <div className="form-group col-md-6">
                    <Field
                      name="sorumluAdi"
                      label={t("demandCreate.sorumluAdi")}
                      colNumber="-6"
                      component={Select}
                      options={configData && configData.tumKullanicilar.filter(a => a.label && a.label != '').map(a => { return { value: a.label, label: (a.label || '--') } })}
                      buttonLabel = {
                        <>
                          <Button
                            className="btn-xs ml-3 px-2 py-1 rounded-circle"
                            variant="primary"
                            onClick={() => setSorumluAdiTextboxVisibility(!sorumluAdiTextboxVisibility)}
                          >
                              <i className={ "fa fa-" + (sorumluAdiTextboxVisibility ? "minus" : "plus") }/>
                          </Button>
                        </>
                      }
                      readOnly={isDisAvukat}
                      required
                    />
                    { sorumluAdiTextboxVisibility &&
                      <Field
                        name="sorumluAdi"
                        label={t("demandCreate.other")}
                        colNumber="-6 hide-label"
                        component={TextInput}
                        readOnly={isDisAvukat}
                        required
                      />
                    }
                  </div>
                  }
                  {!isDisAvukat && 
                    <div className="form-group col-md-6">
                      <Field
                        name="sorumluEposta"
                        label={t("demandCreate.sorumluEPosta")}
                        colNumber="-6"
                        component={Select}
                        options={configData && configData.tumKullanicilar.filter(a => a.otherValue && a.otherValue != '').map(a => { return { value: a.otherValue, label: a.otherValue } })}
                        buttonLabel = {
                          <>
                            <Button
                              className="btn-xs ml-3 px-2 py-1 rounded-circle"
                              variant="primary"
                              onClick={() => setSorumluEpostaTextboxVisibility(!sorumluEpostaTextboxVisibility)}
                            >
                                <i className={ "fa fa-" + (sorumluEpostaTextboxVisibility ? "minus" : "plus") }/>
                            </Button>
                          </>
                        }
                        readOnly={isDisAvukat}
                        required
                      />
                      { sorumluEpostaTextboxVisibility &&
                        <Field
                          name="sorumluEposta"
                          label={t("demandCreate.other")}
                          colNumber="-6 hide-label"
                          component={EmailInput}
                          readOnly={isDisAvukat}
                          required
                        />
                      }
                    </div>
                  }
                  {!isDisAvukat && <Field
                    name="sorumluTel"
                    label={t("documentUpdate.sorumluTelefon")}
                    colNumber="6"
                    component={TextInput}
                    readOnly={isDisAvukat}
                    required
                  />}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                    ]) && (
                      <Field
                        name="davaTuru"
                        label={t("demandUpdate.davaTuru")}
                        colNumber="6"
                        component={Select}
                        options={configData && configData.davaTurleri}
                      />
                    )
                  }
                  
                  {!isDisAvukat && props.selectedRow &&
                    (typeCheck( props.selectedRow.talepTur.id, [
                        DEMAND_TYPES.SAVCILIK,
                        DEMAND_TYPES.PLADIS_SAVCILIK,
                        DEMAND_TYPES.TIO_SAVCILIK,
                        DEMAND_TYPES.DAVA_YENI_TALEP,
                        DEMAND_TYPES.TH_KAMULASTIRMA,
                        DEMAND_TYPES.PLADIS_YENIDAVA,
                        DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                        DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                        DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                        DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                        DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,

                    ])) && (
                      <>
                        <Field
                          name="ilkDavaTuru"
                          label={t("demandUpdate.davaTuru1")}
                          colNumber="6"
                          component={Select}
                          options={getDavaTuru1Options()}
                          onChangeFunc={(val) => {
                              setSlctdDavaTuru(val);
                            }
                          }
                        />
                        {
                          typeCheck(slctdDavaTuru, davaTuru2Types) && <Field
                            name="ikinciDavaTuru"
                            label={t("demandUpdate.davaTuru2")}
                            colNumber="6"
                            component={Select}
                            options={getDavaTuru2()}
                          />
                        }
                      </>
                  )}
                  <Field
                    name="dosyaTuruList"
                    label={t("documentUpdate.dosyaTuru")}
                    colNumber="6"
                    component={MultiSelect}
                    options={configData && configData.dosyaTurleri}
                    isDisabled={isDisAvukat}
                    required
                  />
                  <Field
                    name="konu"
                    label={t("documentUpdate.konu")}
                    colNumber="12"
                    component={TextArea}
                    disabled={isDisAvukat}
                    required
                  />
                  {!isDisAvukat && <Field
                    name="aciklama"
                    label={t("documentUpdate.aciklama")}
                    colNumber="12"
                    component={TextArea}
                    readOnly={isDisAvukat}
                    required
                  />}
                  {props.selectedRow &&
                    typeCheck(
                      props.selectedRow.talepTur.id,
                      [
                        DEMAND_TYPES.FMH_IHTARNAME_HAZIRLANMASI,
                        DEMAND_TYPES.ORTAKLIKJV_KURULUSU,
                        DEMAND_TYPES.SOZLESME,
                        DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI,
                        DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA,
                        DEMAND_TYPES.TIO_SOZLESME,
                        DEMAND_TYPES.ICRA_TAKIBI,
                        DEMAND_TYPES.PLADIS_ICRA,
                        DEMAND_TYPES.TIO_ICRA_TAKIBI,
                        DEMAND_TYPES.DAVA_YENI_TALEP,
                        DEMAND_TYPES.TH_KAMULASTIRMA,
                        DEMAND_TYPES.PLADIS_YENIDAVA,
                        DEMAND_TYPES.GH_IS_HUKUKU,
                        DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                        DEMAND_TYPES.VEKALETNAME,
                        DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI,
                        DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI,
                        DEMAND_TYPES.SAVCILIK,
                        DEMAND_TYPES.PLADIS_SAVCILIK,
                        DEMAND_TYPES.TIO_SAVCILIK,
                        DEMAND_TYPES.FMH_YENI_DAVA,
                        DEMAND_TYPES.FMH_ALEYHE_DAVA,
                        DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                        DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                        DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                        DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                        DEMAND_TYPES.IHTARNAME_HAZIRLANMASI,
                        DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI,
                        DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI,
                        DEMAND_TYPES.TIO_IHTARNAME,
                        DEMAND_TYPES.GENEL_H_IHTARNAME,
                        DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI,
                        DEMAND_TYPES.HACIZ_IHBARNAMELERI,
                        DEMAND_TYPES.PLADIS_HACIZ,
                        DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI,
                        DEMAND_TYPES.RESMI_KURUM_TALEP,
                        DEMAND_TYPES.DAVA_ICRA_HUKUKU_RAPOR,
                        DEMAND_TYPES.MP_RAPORLAMALAR, 
                        DEMAND_TYPES.PLADIS_RAPORLAMALAR,
                        DEMAND_TYPES.TIO_RAPORLAMALAR,
                        DEMAND_TYPES.FMH_RAPORLAMALAR
                      ]
                    ) && (
                      <div className="form-group col-md-6">
                        <Field
                          name="tarafCompanyList"
                          label={t(tarafText)}
                          colNumber="-6"
                          component={MultiSelect}
                          options={combineCompanies.map(item => { return { value: item.id, label: item.name } })}
                          readOnly={isDisAvukat}
                          required
                        />
                        <Field
                          name="taraf1"
                          label={t(tarafText)}
                          colNumber="-6 hide-label"
                          component={TextInput}
                          readOnly={isDisAvukat}
                        /*required*/
                        />
                      </div>
                    )}
                  {props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      //DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.SAVCILIK,
                      DEMAND_TYPES.PLADIS_SAVCILIK,
                      DEMAND_TYPES.TIO_SAVCILIK,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI
                    ]) && (
                      <div className="form-group col-md-6">
                        <Field
                          name="davaliCompanyList"
                          label={t(
                            ((props.selectedRow.talepTur.id == DEMAND_TYPES.SAVCILIK) || (props.selectedRow.talepTur.id == DEMAND_TYPES.TIO_SAVCILIK) || (props.selectedRow.talepTur.id == DEMAND_TYPES.PLADIS_SAVCILIK))
                              ? "demandCreate.supheli"
                              : ((props.selectedRow.talepTur.id ===
                                DEMAND_TYPES.ICRA_TAKIBI) || (props.selectedRow.talepTur.id ===
                                  DEMAND_TYPES.TIO_ICRA_TAKIBI) || (props.selectedRow.talepTur.id === DEMAND_TYPES.PLADIS_ICRA))
                                ? "demandCreate.borclu"
                                : "demandCreate.davali"
                          )}
                          colNumber="-6"
                          component={MultiSelect}
                          options={combineCompanies.map(item => { return { value: item.id, label: item.name } })}
                          readOnly={isDisAvukat}
                          required
                        />
                        <Field
                          name="davali"
                          label={t(
                            ((props.selectedRow.talepTur.id == DEMAND_TYPES.SAVCILIK) || (props.selectedRow.talepTur.id == DEMAND_TYPES.TIO_SAVCILIK) || (props.selectedRow.talepTur.id == DEMAND_TYPES.PLADIS_SAVCILIK))
                              ? "demandCreate.supheli"
                              : ((props.selectedRow.talepTur.id ===
                                DEMAND_TYPES.ICRA_TAKIBI) || (props.selectedRow.talepTur.id ===
                                  DEMAND_TYPES.TIO_ICRA_TAKIBI) || (props.selectedRow.talepTur.id === DEMAND_TYPES.PLADIS_ICRA))
                                ? "demandCreate.borclu"
                                : "demandCreate.davali"
                          )}
                          colNumber="-6 hide-label"
                          component={TextInput}
                          readOnly={isDisAvukat}
                        /*required*/
                        />
                      </div>
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [22, 33, DEMAND_TYPES.TIO_IHTARNAME, DEMAND_TYPES.GENEL_H_IHTARNAME, DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI, DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI]) && (
                      <div className="form-group col-md-6">
                        <Field
                          name="davaliCompanyList"
                          label={t("demandCreate.ihtarEden")}
                          colNumber="-6"
                          component={MultiSelect}
                          options={combineCompanies.map(item => { return { value: item.id, label: item.name } })}
                          required
                        />
                        <Field
                          name="ihtarEden"
                          label={t("demandCreate.ihtarEden")}
                          colNumber="-6 hide-label"
                          component={TextInput}
                        /*required*/
                        />
                      </div>
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    !typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.SINAI_HAKLAR_BEYAN,
                      DEMAND_TYPES.GLOBAL_HUKUK_ISLERI,
                      DEMAND_TYPES.BASKANLIK_TOPLANTI,
                      DEMAND_TYPES.TIO_MUTALAA,
                     /* DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,*/
                      DEMAND_TYPES.MARKA_PATENT,
                      DEMAND_TYPES.FMH_IHTARNAME_HAZIRLANMASI,
                      DEMAND_TYPES.SINAI_MULKIYET_HAKLARI,
                      DEMAND_TYPES.REKLAM_SENARYOSU,
                      DEMAND_TYPES.REKLAM_DIGER,
                      DEMAND_TYPES.BILISIM_VE_INTERNET,
                      DEMAND_TYPES.FMH_ILISKIN_HUKUKI_GORUS,
                      DEMAND_TYPES.MP_MUTALAADANISMA,
                      DEMAND_TYPES.FMH_ILISKIN_RAPORLAMALAR,
                      DEMAND_TYPES.FMH_TOPLANTI,
                      DEMAND_TYPES.FMH_EGITIM,
                      //DEMAND_TYPES.DAVA_YENI_TALEP,
                      //DEMAND_TYPES.GH_IS_HUKUKU,
                      //DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.HACIZ_IHBARNAMELERI,
                      DEMAND_TYPES.PLADIS_HACIZ,
                      DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI,
                      DEMAND_TYPES.BASIN_HUKUKU,
                      DEMAND_TYPES.TIO_BASIN_HUKUKU,
                      DEMAND_TYPES.SAVCILIK,
                      DEMAND_TYPES.PLADIS_SAVCILIK,
                      DEMAND_TYPES.TIO_SAVCILIK,
                      DEMAND_TYPES.MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
                      DEMAND_TYPES.TIO_MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
                      DEMAND_TYPES.PLADIS_MAHKEMELERDENGELENYAZILAR,
                      DEMAND_TYPES.DAVA_ICRA_HUKUKU_RAPOR,
                      DEMAND_TYPES.MP_RAPORLAMALAR, 
                      DEMAND_TYPES.PLADIS_RAPORLAMALAR,
                      DEMAND_TYPES.TIO_RAPORLAMALAR,
                      DEMAND_TYPES.FMH_RAPORLAMALAR,
                      DEMAND_TYPES.IS_HUKUKU_FESIH,
                      DEMAND_TYPES.DAVA_ICRA_TOPLANTI,
                      DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI,
                      DEMAND_TYPES.DAVA_ICRA_EGITIM,
                      DEMAND_TYPES.TIO_SIRKETEGITIM,
                      DEMAND_TYPES.DAVA_ICRA_H_YURTDISI_IHTILAFLARIN_KORDINASYONU,
                      DEMAND_TYPES.IHTARNAME_HAZIRLANMASI,
                      DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI,
                      DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI,
                      DEMAND_TYPES.TIO_MUTALAA,
                      DEMAND_TYPES.RESMI_KURUM_TALEP,
                      DEMAND_TYPES.GENEL_H_KISISEL_VERILER_SURECLER,
                      DEMAND_TYPES.HUKUKI_GORUS_TALEPLERI,
                      DEMAND_TYPES.SPK_MEVZUATI,
                      DEMAND_TYPES.MEVZUAT_INCELEME,
                      DEMAND_TYPES.DIGER_GENEL_HUKUK,
                      DEMAND_TYPES.REKABET_HUKUKU_IZIN_BASVURU,
                      DEMAND_TYPES.REKABET_HUKUKU_SORUSTURMALAR,
                      DEMAND_TYPES.HALKA_ACIK_SIRKET,
                      DEMAND_TYPES.GENEL_HUKUK_TOPLANTI,
                      DEMAND_TYPES.GENEL_HUKUK_EGITIM,
                      DEMAND_TYPES.GENEL_H_IHTARNAME
                    ]) && (
                      <Field
                        name="szlThmBedelTuru"
                        label={t(
                          ((props.selectedRow.talepTur.id === DEMAND_TYPES.SOZLESME) || 
                          (props.selectedRow.talepTur.id == DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI) || 
                          (props.selectedRow.talepTur.id == DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA) || 
                          (props.selectedRow.talepTur.id == DEMAND_TYPES.TIO_SOZLESME) || 
                          (props.selectedRow.talepTur.id === DEMAND_TYPES.GH_IS_HUKUKU))
                            ? "demandCreate.sozlesmeBedeli"
                            : "documentUpdate.tahminiBedel"
                        )}
                        colNumber="6"
                        component={Select}
                        options={
                          configData && configData.szlTahminiBedelTurleri
                        }
                        onChangeFunc={(val) => onBedelChanged(val)}
                        required
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    !typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      DEMAND_TYPES.SINAI_HAKLAR_BEYAN,
                      DEMAND_TYPES.GLOBAL_HUKUK_ISLERI,
                      DEMAND_TYPES.BASKANLIK_TOPLANTI,
                      DEMAND_TYPES.TIO_MUTALAA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                      DEMAND_TYPES.MARKA_PATENT,
                      DEMAND_TYPES.FMH_IHTARNAME_HAZIRLANMASI,
                      DEMAND_TYPES.SINAI_MULKIYET_HAKLARI,
                      DEMAND_TYPES.REKLAM_SENARYOSU,
                      DEMAND_TYPES.REKLAM_DIGER,
                      DEMAND_TYPES.BILISIM_VE_INTERNET,
                      DEMAND_TYPES.FMH_ILISKIN_HUKUKI_GORUS,
                      DEMAND_TYPES.MP_MUTALAADANISMA,
                      DEMAND_TYPES.FMH_ILISKIN_RAPORLAMALAR,
                      DEMAND_TYPES.FMH_TOPLANTI,
                      DEMAND_TYPES.FMH_EGITIM,
                      DEMAND_TYPES.RESMI_KURUM_TALEP,
                      DEMAND_TYPES.GENEL_H_KISISEL_VERILER_SURECLER,
                      DEMAND_TYPES.HUKUKI_GORUS_TALEPLERI,
                      DEMAND_TYPES.SPK_MEVZUATI,
                      DEMAND_TYPES.MEVZUAT_INCELEME,
                      DEMAND_TYPES.DIGER_GENEL_HUKUK,
                      DEMAND_TYPES.REKABET_HUKUKU_IZIN_BASVURU,
                      DEMAND_TYPES.REKABET_HUKUKU_SORUSTURMALAR,
                      DEMAND_TYPES.HALKA_ACIK_SIRKET,
                      DEMAND_TYPES.GENEL_HUKUK_TOPLANTI,
                      DEMAND_TYPES.GENEL_HUKUK_EGITIM,
                      DEMAND_TYPES.GENEL_H_IHTARNAME
                    ]) && (
                      <Field
                        name="bedel"
                        label={t(
                          props.selectedRow.talepTur.id ===
                            DEMAND_TYPES.DAVA_YENI_TALEP ||
                            props.selectedRow.talepTur.id ===
                            DEMAND_TYPES.PLADIS_YENIDAVA ||
                            props.selectedRow.talepTur.id ===
                            DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI ||
                            props.selectedRow.talepTur.id ===
                            DEMAND_TYPES.TH_KAMULASTIRMA
                            ? "demandCreate.davaTutari"
                            : ((props.selectedRow.talepTur.id ===
                              DEMAND_TYPES.ICRA_TAKIBI) || (props.selectedRow.talepTur.id ===
                                DEMAND_TYPES.TIO_ICRA_TAKIBI) || (props.selectedRow.talepTur.id === DEMAND_TYPES.PLADIS_ICRA))
                              ? "demandCreate.takipTutari"
                              : "documentUpdate.bedel"
                        )}
                        colNumber="6"
                        component={CurrencyInput}
                        readOnly={
                          isDisAvukat || bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                        placeholder="0,00"
                        resetValue={
                          bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                        required
                      />
                    )}
                    {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                    ]) && (
                      <Field
                        name="bedel"
                        label={typeCheck(props.selectedRow.talepTur.id, [
                          DEMAND_TYPES.TIO_MUTALAA,
                          DEMAND_TYPES.TIO_IHTARNAME,
                          DEMAND_TYPES.TIO_SOZLESME,
                          DEMAND_TYPES.TIO_SOZLESMELERLE_ILGILI_SORU,
                          DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI,
                          DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                          DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                          DEMAND_TYPES.TIO_SAVCILIK,
                          DEMAND_TYPES.TIO_ICRA_TAKIBI,
                          DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI,
                          DEMAND_TYPES.TIO_MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
                          DEMAND_TYPES.TIO_RAPORLAMALAR,
                          DEMAND_TYPES.TIO_SIRKETEGITIM,
                          DEMAND_TYPES.IS_HUKUKU_FESIH,
                          DEMAND_TYPES.DAVA_ICRA_TOPLANTI,
                          113
                        ]) ? t("demandCreate.muddeabihRisk") : t("demandCreate.muddeabih")}
                        colNumber="6"
                        component={CurrencyInput}
                        readOnly={
                          isDisAvukat || bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                        placeholder="0,00"
                        resetValue={
                          bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                      /*required*/
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    !typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.SINAI_HAKLAR_BEYAN,
                      DEMAND_TYPES.GLOBAL_HUKUK_ISLERI,
                      DEMAND_TYPES.BASKANLIK_TOPLANTI,
                      DEMAND_TYPES.TIO_MUTALAA,
                      DEMAND_TYPES.MARKA_PATENT,
                      DEMAND_TYPES.FMH_IHTARNAME_HAZIRLANMASI,
                      DEMAND_TYPES.SINAI_MULKIYET_HAKLARI,
                      DEMAND_TYPES.REKLAM_SENARYOSU,
                      DEMAND_TYPES.REKLAM_DIGER,
                      DEMAND_TYPES.BILISIM_VE_INTERNET,
                      DEMAND_TYPES.FMH_ILISKIN_HUKUKI_GORUS,
                      DEMAND_TYPES.MP_MUTALAADANISMA,
                      DEMAND_TYPES.FMH_ILISKIN_RAPORLAMALAR,
                      DEMAND_TYPES.FMH_TOPLANTI,
                      DEMAND_TYPES.FMH_EGITIM,
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                      DEMAND_TYPES.RESMI_KURUM_TALEP,
                      DEMAND_TYPES.GENEL_H_KISISEL_VERILER_SURECLER,
                      DEMAND_TYPES.HUKUKI_GORUS_TALEPLERI,
                      DEMAND_TYPES.SPK_MEVZUATI,
                      DEMAND_TYPES.MEVZUAT_INCELEME,
                      DEMAND_TYPES.DIGER_GENEL_HUKUK,
                      DEMAND_TYPES.REKABET_HUKUKU_IZIN_BASVURU,
                      DEMAND_TYPES.REKABET_HUKUKU_SORUSTURMALAR,
                      DEMAND_TYPES.HALKA_ACIK_SIRKET,
                      DEMAND_TYPES.GENEL_HUKUK_TOPLANTI,
                      DEMAND_TYPES.GENEL_HUKUK_EGITIM,
                      DEMAND_TYPES.GENEL_H_IHTARNAME
                    ]) && (
                      <Field
                        name="paraBirimi"
                        label={t("documentUpdate.paraBirimi")}
                        colNumber="6"
                        component={Select}
                        options={configData && configData.paraBirimleri}
                        isDisabled={
                          isDisAvukat || bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                        resetValue={
                          bedel === 14 || bedel === 15 ||
                          props?.selectedRow?.szlThmBedelTuru === 14
                        }
                        required
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    !typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.SINAI_HAKLAR_BEYAN,
                      DEMAND_TYPES.GLOBAL_HUKUK_ISLERI,
                      DEMAND_TYPES.BASKANLIK_TOPLANTI,
                      DEMAND_TYPES.TIO_MUTALAA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      //DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.SAVCILIK,
                      DEMAND_TYPES.PLADIS_SAVCILIK,
                      DEMAND_TYPES.TIO_SAVCILIK,
                      DEMAND_TYPES.IS_HUKUKU_FESIH,
                      DEMAND_TYPES.HACIZ_IHBARNAMELERI,
                      DEMAND_TYPES.PLADIS_HACIZ,
                      DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI,
                      DEMAND_TYPES.BASIN_HUKUKU,
                      DEMAND_TYPES.TIO_BASIN_HUKUKU,
                      DEMAND_TYPES.IHTARNAME_HAZIRLANMASI,
                      DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI,
                      DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI,
                      DEMAND_TYPES.TIO_MUTALAA,
                      DEMAND_TYPES.MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
                      DEMAND_TYPES.TIO_MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
                      DEMAND_TYPES.PLADIS_MAHKEMELERDENGELENYAZILAR,
                      DEMAND_TYPES.DAVA_ICRA_HUKUKU_RAPOR,
                      DEMAND_TYPES.MP_RAPORLAMALAR, 
                      DEMAND_TYPES.PLADIS_RAPORLAMALAR,
                      DEMAND_TYPES.TIO_RAPORLAMALAR,
                      DEMAND_TYPES.FMH_RAPORLAMALAR,
                      DEMAND_TYPES.DAVA_ICRA_TOPLANTI,
                      DEMAND_TYPES.DAVA_ICRA_EGITIM,
                      DEMAND_TYPES.TIO_SIRKETEGITIM,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                      DEMAND_TYPES.MARKA_PATENT,
                      DEMAND_TYPES.FMH_IHTARNAME_HAZIRLANMASI,
                      DEMAND_TYPES.SINAI_MULKIYET_HAKLARI,
                      DEMAND_TYPES.REKLAM_SENARYOSU,
                      DEMAND_TYPES.REKLAM_DIGER,
                      DEMAND_TYPES.BILISIM_VE_INTERNET,
                      DEMAND_TYPES.FMH_ILISKIN_HUKUKI_GORUS,
                      DEMAND_TYPES.MP_MUTALAADANISMA,
                      DEMAND_TYPES.FMH_ILISKIN_RAPORLAMALAR,
                      DEMAND_TYPES.FMH_TOPLANTI,
                      DEMAND_TYPES.FMH_EGITIM,
                      DEMAND_TYPES.DAVA_ICRA_H_YURTDISI_IHTILAFLARIN_KORDINASYONU,
                    ]) && (
                      <Field
                        name="dil"
                        label={t("documentUpdate.dil")}
                        colNumber="6"
                        component={Select}
                        options={configData && configData.diller}
                        required
                      />
                    )}
                  {/*!isDisAvukat && <Field
                    name="baslangicTarihi"
                    label={t("documentUpdate.baslangicTarihi")}
                    colNumber="6"
                    component={ReactDatePicker}
                  />}
                  {/*!isDisAvukat && <Field
                    name="bitisTarihi"
                    label={t("documentUpdate.bitisTarihi")}
                    colNumber="6"
                    component={ReactDatePicker}
                  />*/}
                  <Field
                    name="avukatYorumu"
                    label={t("documentUpdate.avukatYorumu")}
                    colNumber="6"
                    component={TextArea}
                  />
                  { props.selectedRow && props.selectedRow.avukat && (userObj.id === props.selectedRow.avukat.id || userObj.id === props.selectedRow.createdUser?.id) && !isDisAvukat && <Field
                    name="yonlendiriciYorum"
                    label={t("documentUpdate.yonlendiriciYorumu")}
                    colNumber="6"
                    component={TextArea}
                  />}
                  {!isDisAvukat && <Field
                    name="yorumlar"
                    label={t("documentUpdate.yorumlar")}
                    colNumber="6"
                    component={TextArea}
                  />}
                  {props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      //DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.SAVCILIK,
                      DEMAND_TYPES.PLADIS_SAVCILIK,
                      DEMAND_TYPES.TIO_SAVCILIK,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI,
                    ]) && (
                      <Field
                        name="daireNo"
                        label={t(
                          ((
                            props.selectedRow.talepTur.id === DEMAND_TYPES.SAVCILIK) || 
                            (props.selectedRow.talepTur.id === DEMAND_TYPES.PLADIS_SAVCILIK) ||
                            (props.selectedRow.talepTur.id === DEMAND_TYPES.TIO_SAVCILIK) ||
                            (props.selectedRow.talepTur.id === DEMAND_TYPES.PLADIS_SAVCILIK))
                            ? "demandUpdate.savcilikNo"
                              : "demandUpdate.daireNo"
                        )}
                        colNumber="6"
                        component={TextInput}
                      /*required*/
                      />
                    )}
                  {props.selectedRow &&
                  typeCheck(props.selectedRow.talepTur.id, [
                    /*DEMAND_TYPES.DAVA_YENI_TALEP,
                    DEMAND_TYPES.GH_IS_HUKUKU,
                    DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                    DEMAND_TYPES.SAVCILIK,
                    DEMAND_TYPES.TIO_SAVCILIK,
                    DEMAND_TYPES.FMH_YENI_DAVA,
                    DEMAND_TYPES.FMH_ALEYHE_DAVA,
                    DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                    DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,*/
                    DEMAND_TYPES.ICRA_TAKIBI,
                    DEMAND_TYPES.PLADIS_ICRA,
                    DEMAND_TYPES.TIO_ICRA_TAKIBI,
                    /*DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI,*/
                  ]) && (
                      <Field
                          name="icraNo"
                          label={t( "demandUpdate.icraNo"
                          )}
                          colNumber="6"
                          component={TextInput}
                          /*required*/
                      />
                  )}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTurId, [9]) && (
                      <Field
                        name="basvurulanSirket"
                        label={t("demandCreate.basvuruYapilacakSirket")}
                        colNumber="6"
                        component={TextInput}
                        required
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepDurumId, [
                      DEMAND_TYPES.YONETIM_KURULU_KARARLARI,
                    ]) && (
                      <Field
                        name="redNedeni"
                        label={t("demandUpdate.redNedeni")}
                        colNumber="6"
                        component={TextInput}
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepDurumId, [
                      DEMAND_TYPES.YONETIM_KURULU_KARARLARI,
                    ]) && (
                      <Field
                        name="redEdenUserId"
                        label={t("demandUpdate.redEdenKullanici")}
                        colNumber="6"
                        component={TextInput}
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepDurumId, [
                      DEMAND_TYPES.YONETIM_KURULU_KARARLARI,
                    ]) && (
                      <Field
                        name="redTarihi"
                        label={t("demandUpdate.redTarihi")}
                        colNumber="6"
                        component={ReactDatePicker}
                      />
                    )}
                  {props.selectedRow && typeCheck(props.selectedRow.talepTur.id, [
                    64,
                    17,
                    90,
                    92,
                    83,
                    31,
                    DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                    DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                    DEMAND_TYPES.PLADIS_ICRA
                  ]) && (
                      <Field
                        name="mudahil"
                        label={t("demandCreate.müdahil")}
                        colNumber="6"
                        component={TextInput}
                      /*required*/
                      />
                    )}
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.VEKALETNAME,
                      DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI,
                      DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI,
                    ]) && (
                      <Field
                        name="vekilSirket"
                        label={t("demandCreate.vekilinCalistigiSirket")}
                        colNumber="6"
                        component={TextInput}
                        readOnly={isDisAvukat}
                      /*required*/
                      />
                    )}
                  {props.selectedRow &&
                    typeCheck(
                      props.selectedRow.talepTur.id,
                      [64, 17, 18, 26, 25, 16, 69, 80, 31, 83, 89, 90, 91, 92, DEMAND_TYPES.PLADIS_SAVCILIK, DEMAND_TYPES.PLADIS_ALEYHEACILAN, DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI, DEMAND_TYPES.MP_YURTDISIYENIDAVAACILMASI, DEMAND_TYPES.PLADIS_ICRA, DEMAND_TYPES.PLADIS_YENIDAVA, DEMAND_TYPES.TH_KAMULASTIRMA]
                    ) && (
                      <Field
                        name="davaTarihi"
                        label={t("demandCreate.durusmaTarihi")}
                        colNumber="6"
                        component={ReactDatePicker}
                      />
                    )}
                  {!isDisAvukat && 
                  <div className="form-group col-md-6">
                    <Field
                      name="isGucuBirimId"
                      label={t("demandUpdate.isGucuBirim")}
                      colNumber="-6"
                      component={Select}
                      menuPlacement={'top'}
                      onChangeFunc={(val) => onIsGucuBirimChange(val)}
                      options={configData && configData.isGucu}
                      isDisabled={isDisAvukat || disableIsGucu}
                      required  
                    />
                      {
                        isGucuTextboxVisibility && <Field
                          name="isGucuBirimIdDiger"
                          label={t("demandUpdate.isGucuBirimDiger")}
                          colNumber="-6 hide-label"
                          component={TextInput}
                          resetValue={isGucuTextboxVisibility}
                        />
                      }
                  </div>
                  }
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [89, 90, 92, 16, 64, 17, 91, 31, 83, 18, DEMAND_TYPES.PLADIS_SAVCILIK, DEMAND_TYPES.PLADIS_ALEYHEACILAN, DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI, DEMAND_TYPES.MP_YURTDISIYENIDAVAACILMASI, DEMAND_TYPES.PLADIS_ICRA, DEMAND_TYPES.PLADIS_YENIDAVA, DEMAND_TYPES.TH_KAMULASTIRMA]) && (
                    <Field
                      name="updateOnemli"
                      label={t("demandUpdate.importantInfo")}
                      colNumber="6"
                      component={Checkbox}
                      value={props.selectedRow?.onemli ? true : false} 
                    />
                  )}
                  {
                    /* (props.selectedRow && (props.selectedRow.talepDurum.id == 2 || props.selectedRow.talepDurum.id == 1)) &&  */
                    !isDisAvukat && 
                    <>
                      <Field
                        name="avukatId"
                        label={t("demandUpdate.delegeEdilen")}
                        colNumber="6"
                        component={Select}
                        options={configData && configData.users}
                        isDisabled={isDisAvukat}
                        required     
                      />
                      <Field
                        name="bilgideTutulanlar"
                        label={t("demandUpdate.bilgideTut")}
                        colNumber="6"
                        component={MultiSelect}
                        options={configData && configData.bilgideTutList}
                        isDisabled={isDisAvukat}
                      />
                    </>
                  }
                  {!isDisAvukat && props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      //DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.SAVCILIK,
                      DEMAND_TYPES.PLADIS_SAVCILIK,
                      DEMAND_TYPES.TIO_SAVCILIK,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                    ]) && (
                      <Field
                        name="gorevlendirilmisDisAvukatlar"
                        label={t("demandUpdate.gorevlendirilenDisAvukat")}
                        colNumber="6"
                        component={MultiSelect}
                        options={configData && configData.disAvukatlar}
                        isDisabled={isDisAvukat}
                        maxLimit={2}
                      />
                    )}
                  {!isDisAvukat && props.selectedRow && (props.selectedRow.gorevlendirilenDisAvukatFullName && props.selectedRow.gorevlendirilmisDisAvukatlar.length == 0) &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      //DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.SAVCILIK,
                      DEMAND_TYPES.PLADIS_SAVCILIK,
                      DEMAND_TYPES.TIO_SAVCILIK,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                    ]) && (
                      <Field
                        name="gorevlendirilenDisAvukat"
                        label={t("demandUpdate.gorevlendirilenDisAvukatDiger")}
                        colNumber="6"
                        component={TextInput}
                        readOnly
                      />
                    )}
                  {props.selectedRow &&
                    typeCheck(props.selectedRow.talepTur.id, [
                      DEMAND_TYPES.SOZLESME,
                      DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI,
                      DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA,
                      DEMAND_TYPES.TIO_SOZLESME,
                      DEMAND_TYPES.VEKALETNAME,
                      DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI,
                      DEMAND_TYPES.TIO_VEKALETNAME_HAZIRLANMASI,
                      DEMAND_TYPES.ORTAKLIKJV_KURULUSU,
                      DEMAND_TYPES.FMH_YENI_DAVA,
                      DEMAND_TYPES.FMH_ALEYHE_DAVA,
                      DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.PLADIS_ALEYHEACILAN,
                      DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
                      DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
                      DEMAND_TYPES.ICRA_TAKIBI,
                      DEMAND_TYPES.PLADIS_ICRA,
                      DEMAND_TYPES.TIO_ICRA_TAKIBI,
                      DEMAND_TYPES.DAVA_YENI_TALEP,
                      DEMAND_TYPES.TH_KAMULASTIRMA,
                      DEMAND_TYPES.PLADIS_YENIDAVA,
                      DEMAND_TYPES.GH_IS_HUKUKU,
                      DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
                      DEMAND_TYPES.SAVCILIK,
                      DEMAND_TYPES.PLADIS_SAVCILIK,
                      DEMAND_TYPES.TIO_SAVCILIK,
                    ]) && (
                      <Field
                        name="dosyaDurumId"
                        label={t("documentUpdate.dosyaDurum")}
                        colNumber="6"
                        component={Select}
                        menuPlacement={'top'}
                        options={configData && configData.dosyaDurum}
                      />
                    )}
                  {/* {props.selectedRow &&
                    !typeCheck(
                      props.selectedRow.talep
                        ? props.selectedRow.talep.talepTur.id
                        : props.selectedRow.talepTur.id,
                      [3]
                    ) && (
                      <Field
                        name="sicilKaydiValue"
                        checkboxText={t("documentUpdate.sicilKaydiVar")}
                        colNumber="6"
                        component={Checkbox}
                      />
                    )}
                  {props.selectedRow &&
                    !typeCheck(
                      props.selectedRow.talep
                        ? props.selectedRow.talep.talepTur.id
                        : props.selectedRow.talepTur.id,
                      [3]
                    ) && (
                      <Field
                        name="sirkularValue"
                        checkboxText={t("documentUpdate.sirkulerVar")}
                        colNumber="6"
                        component={Checkbox}
                      />
                    )}
                  {props.selectedRow &&
                    !typeCheck(
                      props.selectedRow.talep
                        ? props.selectedRow.talep.talepTur.id
                        : props.selectedRow.talepTur.id,
                      [3]
                    ) && (
                      <Field
                        name="cezaValue"
                        checkboxText={t("documentUpdate.cezaVar")}
                        colNumber="6"
                        component={Checkbox}
                      />
                    )} */}
                </FormikForm>
              </Tab.Pane>
              <Tab.Pane eventKey={"sondurum"} key={2}>
                <LastStatus
                  refreshList={() => props.setRefreshList(!props.refreshList)}
                  selectedRow={props.selectedRow}
                  disableButtons={disableButtons}
                />
              </Tab.Pane>

              <Tab.Pane eventKey={"dokumanlar"} key={3}>
                <Documents
                  selectedRow={props.selectedRow}
                  disableButtons={disableButtons}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={"harcanansureler"} key={4}>
                <TimesSpent
                  selectedRow={props.selectedRow}
                  disableButtons={disableButtons}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={"dosyagecmisi"} key={5}>
                <DocumentHistory selectedRow={props.selectedRow} />
              </Tab.Pane>
              { props.selectedRow && IsMasrafCheck && (typeCheck(props.selectedRow.talepTur.id, MASRAF_TAB_CASES )) && (
                <Tab.Pane eventKey={"masraflar"} key={6}>
                  <Expenses selectedRow={props.selectedRow} isUpdating={props.isUpdating} />
                  <Documents
                    selectedRow={props.selectedRow}
                    disableButtons={disableButtons}
                    masrafMi={ true }
                  />
                </Tab.Pane>
              )}
            </Tab.Content>
          </Tab.Container>
        </CrudMain>
      </div>
    </div>
  );
}

export default DocumentUpdate;
